// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyC1vsl9lQQBXaDpNmE7EAmFV9Y5q65t7kE",
    authDomain: "my-angular-site.firebaseapp.com",
    databaseURL: "https://my-angular-site.firebaseio.com",
    projectId: "my-angular-site",
    storageBucket: "my-angular-site.appspot.com",
    messagingSenderId: "194975598566"
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts